const NotificationTicketIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.67188 3.33309C1.67188 2.87285 2.04498 2.49976 2.50521 2.49976H17.5052C17.9655 2.49976 18.3386 2.87285 18.3386 3.33309V7.91642C17.188 7.91642 16.2552 8.84918 16.2552 9.99976C16.2552 11.1503 17.188 12.0831 18.3386 12.0831V16.6664C18.3386 17.1267 17.9655 17.4998 17.5052 17.4998H2.50521C2.04498 17.4998 1.67188 17.1267 1.67188 16.6664V3.33309ZM6.74301 15.8331C6.9146 15.3476 7.37762 14.9998 7.92188 14.9998C8.46614 14.9998 8.92914 15.3476 9.10073 15.8331H16.6719V13.3599C15.4371 12.7463 14.5886 11.4721 14.5886 9.99976C14.5886 8.52735 15.4371 7.25318 16.6719 6.63956V4.16642H9.10073C8.92914 4.65191 8.46614 4.99976 7.92188 4.99976C7.37762 4.99976 6.9146 4.65191 6.74301 4.16642H3.33854V15.8331H6.74301ZM7.92188 9.16643C7.23153 9.16643 6.67188 8.60676 6.67188 7.91642C6.67188 7.22606 7.23153 6.66642 7.92188 6.66642C8.61223 6.66642 9.17189 7.22606 9.17189 7.91642C9.17189 8.60676 8.61223 9.16643 7.92188 9.16643ZM7.92188 13.3331C7.23153 13.3331 6.67188 12.7734 6.67188 12.0831C6.67188 11.3928 7.23153 10.8331 7.92188 10.8331C8.61223 10.8331 9.17189 11.3928 9.17189 12.0831C9.17189 12.7734 8.61223 13.3331 7.92188 13.3331Z"
      fill="white"
    />
  </svg>
);

export default NotificationTicketIcon;
